import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Button from '../Button'
import { Copy } from '../../icons'

const CopyButton = ({
  copiedText,
  className,
  tooltipSide = 'left',
  ...otherProps
}) => {
  const copyTextToClipboard = async () => {
    if ('clipboard' in navigator) {
      await navigator.clipboard
        .writeText(copiedText)
    } else {
      return document.execCommand('copy', true, copiedText)
    }
  }

  return (
    <Button
      className={classnames(
        'vs-u-copy-button',
        {'vs-u-copy-button--has-tooltip-left': tooltipSide === 'left'},
        {'vs-u-copy-button--has-tooltip-right': tooltipSide === 'right'},
        className
      )}
      colorVariant='brand'
      size='small'
      fill='none'
      icon={<Copy />}
      title='copy'
      onClick={() => copyTextToClipboard()}
      {...otherProps}
    >
      Copy
    </Button>
  )
}

CopyButton.propTypes = {
  /**
   * A text to be copied
   */
  copiedText: PropTypes.string,
  /**
   * Shift the side of the tooltip
   */
  tooltipSide: PropTypes.string
}

export default CopyButton
